import React, { useEffect } from 'react'
import { string, func, bool, object } from 'prop-types'

const Image = ({
  src,
  cssImageClass,
  callback = () => { },
  value,
  prop,
  title,
  alt = '',
  cssFigureClass = '',
  isLazy = false,
  otherProps = {}
}) => {
  otherProps = { src }
  if (isLazy) {
    delete otherProps.src
    otherProps.loading = 'lazy'
  }

  const runCallback = e => {
    if (value || typeof value === 'boolean') {
      prop ? callback(prop, value) : callback(value)
    } else {
      callback(e)
    }
  }

  const imageRef = React.createRef()

  useEffect(() => {
    if (isLazy) {
      const options = {
        root: document.body,
        rootMargin: '0px',
        threshold: 0
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('src', src)
          }
        })
      }, options)
      observer.observe(imageRef.current)
    }
  }, [])

  return (
    <figure className={`image ${cssFigureClass}`} onClick={e => runCallback(e)}>
      <img className={cssImageClass} {...otherProps} alt={alt} ref={imageRef} />
      {title !== '' ? <span>{title}</span> : <></>}
    </figure>
  )
}

Image.propTypes = {
  src: string,
  cssFigureClass: string,
  cssImageClass: string,
  callback: func,
  alt: string,
  isLazy: bool,
  otherProps: object,
  prop: string,
  title: string,
  value: string
}

export default Image
